import { render } from "./RegistrationStatus.vue?vue&type=template&id=4a0b2978"
import script from "./RegistrationStatus.vue?vue&type=script&lang=js"
export * from "./RegistrationStatus.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__